import { TWorkflowDefinition, WorkflowStepType } from '@commenda/types';

export class WorkflowHelper {
  static isHuman(type: string) {
    return type.startsWith('human.');
  }

  static isStart(type: string) {
    return type === WorkflowStepType.START;
  }

  static isGateway(type: string) {
    return type.startsWith('gateway.');
  }

  static isEnd(type: string) {
    return type === WorkflowStepType.END;
  }

  static getStepGroupInfo(
    stepId: string,
    workflow: TWorkflowDefinition
  ): { groupId: string; name: string; position: number } | null {
    if (!workflow) return null;
    if (!workflow.stepGroups || workflow.stepGroups.length === 0) return null;

    const stepGroup = workflow.stepGroups.find((g) =>
      g.stepIds.includes(stepId)
    );

    if (!stepGroup) return null;

    return {
      groupId: stepGroup.id,
      name: stepGroup.name,
      position: stepGroup.stepIds.indexOf(stepId) + 1,
    };
  }
}
